import React from 'react';

// Live stream-stats panel. Values are refreshed by the parent (App.js polls
// every second while open), so the green pulse + "live" label reflect reality.
const StatsModal = ({ stats, onClose }) => {
  const entries = stats ? Object.entries(stats) : [];

  return (
    <div
      className="modal-overlay-stats"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.45)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
      }}
    >
      <div
        className="modal-content-stats"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(92vw, 420px)',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          background: 'rgba(20,22,27,0.92)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 14,
          boxShadow: '0 12px 44px rgba(0,0,0,0.5)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          overflow: 'hidden',
          fontFamily: 'inherit',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '14px 16px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: '#4ade80',
              animation: 'statsLivePulse 1.6s infinite',
            }}
          />
          <span style={{ fontSize: 15, fontWeight: 600, letterSpacing: 0.2 }}>
            Stream Statistics
          </span>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: 0.6 }}>
            live
          </span>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              marginLeft: 'auto',
              background: 'rgba(255,255,255,0.08)',
              border: 'none',
              color: 'rgba(255,255,255,0.85)',
              width: 28,
              height: 28,
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 16,
              lineHeight: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ overflowY: 'auto', padding: '6px 8px' }}>
          {entries.length === 0 ? (
            <div
              style={{
                padding: 28,
                textAlign: 'center',
                color: 'rgba(255,255,255,0.5)',
                fontSize: 13,
              }}
            >
              Collecting stats…
            </div>
          ) : (
            entries.map(([key, value], i) => (
              <div
                key={key}
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                  gap: 12,
                  padding: '9px 10px',
                  borderRadius: 8,
                  background: i % 2 ? 'rgba(255,255,255,0.035)' : 'transparent',
                }}
              >
                <span style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.62)' }}>{key}</span>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    fontVariantNumeric: 'tabular-nums',
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                    textAlign: 'right',
                    color: '#fff',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {value}
                </span>
              </div>
            ))
          )}
        </div>
      </div>

      <style>{`
        @keyframes statsLivePulse {
          0%   { box-shadow: 0 0 0 0 rgba(74,222,128,0.6); }
          70%  { box-shadow: 0 0 0 7px rgba(74,222,128,0); }
          100% { box-shadow: 0 0 0 0 rgba(74,222,128,0); }
        }
      `}</style>
    </div>
  );
};

export default StatsModal;
